import React from 'react';
import { Box, Text, Center } from '@mantine/core';

const DiscoveryPrompt = ({ svgLink, description, onClick }) => {
  const descriptionsentencees = description.split('.');
  return (
    <Box
      onClick={onClick}
      style={{
        cursor: 'pointer',
        left: '25%',
      }}
    >
      <Center style={{ paddingTop: '10vh', paddingBottom: '25px' }}>
        <img src={svgLink} alt="No items" height="20%" width="20%" />
      </Center>
      {descriptionsentencees.map((string, index) => {
        return (
          <Center key={index}>
            <Text size="xl" fw={700} c="#669DF6">
              {string}.
            </Text>
          </Center>
        );
      })}
    </Box>
  );
};

export default DiscoveryPrompt;
